// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"tvOeiF","input":"fQc15R"};